import {
  deleteImageFileOriginal,
  deleteImageFileThumbnail,
  getImageFileOriginal,
  getImageFileThumbnail,
  storageDeleteFile,
} from './firebase/firebase-short-cut';

// ==================== 이미지 삭제 관련 ====================

/**
 * 단일 이미지와 메타 정보 문서를 완전히 삭제합니다 (Storage 파일 + Firestore 레코드)
 */
export const deleteImageFile = async (
  imageFileId: string
): Promise<{ original: boolean; thumbnail: boolean; errors: Error[] }> => {
  const result: { original: boolean; thumbnail: boolean; errors: Error[] } = {
    original: false,
    thumbnail: false,
    errors: [],
  };

  // 1. 원본 이미지 삭제
  try {
    const imageFileOriginalDoc = await getImageFileOriginal(imageFileId);
    if (!imageFileOriginalDoc) {
      result.errors.push(new Error(`Image file original not found: ${imageFileId}`));
      return result;
    }

    await storageDeleteFile(imageFileOriginalDoc.bucket, imageFileOriginalDoc.storagePath);
    await deleteImageFileOriginal(imageFileOriginalDoc._id);
    result.original = true;
  } catch (error) {
    result.errors.push(error as Error);
  }

  // 2. 썸네일 이미지 삭제
  try {
    const imageFileThumbnailDoc = await getImageFileThumbnail(imageFileId);
    if (!imageFileThumbnailDoc) {
      result.errors.push(new Error(`Image file thumbnail not found: ${imageFileId}`));
      return result;
    }

    await storageDeleteFile(imageFileThumbnailDoc.bucket, imageFileThumbnailDoc.storagePath);
    await deleteImageFileThumbnail(imageFileThumbnailDoc._id);
    result.thumbnail = true;
  } catch (error) {
    result.errors.push(error as Error);
  }

  return result;
};
